import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";

const AUTH_IMAGE =
  "https://images.unsplash.com/photo-1578575436955-ef29da568c6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxwZW9wbGUlMjBzY2FubmluZyUyMHRpY2tldHMlMjBldmVudHxlbnwwfHx8fDE3ODMxMjQ0MDl8MA&ixlib=rb-4.1.0&q=85";

export function AuthLayout({ children, quote, testid = "auth-layout" }) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white" data-testid={testid}>
      {/* Left: brand panel */}
      <div className="relative hidden lg:block bg-[var(--gt-ink)] text-white overflow-hidden">
        <img
          src={AUTH_IMAGE}
          alt="Event tickets being scanned"
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-[var(--gt-ink)]/50" />
        <div className="relative h-full flex flex-col justify-between p-10 xl:p-14">
          <Logo inverse size="md" />
          <div className="max-w-md">
            <div className="gt-label text-white/60 mb-4">Australian ticketing</div>
            <p className="font-heading font-black text-4xl xl:text-5xl leading-[1.05] tracking-tight">
              {quote ||
                "Sell out your next Aussie event — from Bondi backyards to Federation Square."}
            </p>
            <p className="mt-6 text-white/70 text-sm">
              Made for organisers. Priced fairly. Paid in AUD.
            </p>
          </div>
          <div className="text-xs tracking-[0.25em] uppercase text-white/50">
            © {new Date().getFullYear()} Getickets
          </div>
        </div>
      </div>

      {/* Right: content */}
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8 flex justify-center">
            <Logo size="md" />
          </div>
          {children}
          <div className="mt-10 text-xs text-[var(--gt-ink-3)] text-center">
            <Link to="/" className="hover:text-[var(--gt-ink)] transition-colors">
              ← Back to home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
